export default __webpack_public_path__ + "static/media/triggers.fa69596d.png";